import { DatePipe } from '@angular/common';
import { Component, EventEmitter, inject, Input, Output, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { DisbursementService } from 'src/app/shared/service/disbursment/disbursement.component.service';
import { PdaService } from 'src/app/shared/service/disbursment/pda.component.service';
import { PortAgentFormService } from 'src/app/shared/service/disbursment/port-agent-form.service';
import { EmailSentNotificationComponent } from '../../pda/email-sent-notification/email-sent-notification.component';
import { formatToLocalISOString } from '../../pda/pda.model';
import { DisbursmentDetails, Disbursment } from '../disbursment.component.model';
import { DisbursmentService } from 'src/app/shared/service/disbursment/disbursment.service';
import { ToastrService } from 'ngx-toastr';
import { FileUploadService } from 'src/app/shared/service/disbursment/file-upload.service';
import { PaymentInstructionLogic } from './payment-instruction-logic';
import { PaymentInstructionDialogComponent } from '../payment-instruction-dialog/payment-instruction-dialog.component';
import { formatDate } from '../disbursment.component.model';
import { FileUploadDisComponent } from '../../pda-edit/file-upload-dis/file-upload-dis.component';
export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'DD/MM/YYYY',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
@Component({
  selector: 'app-disburs-dtls-comp',
  templateUrl: './disburs-dtls-comp.component.html',
  styleUrls: ['./disburs-dtls-comp.component.scss']
})
export class DisbursDtlsCompComponent {
@Input() disbursement_obj: any;
  @Output() disbursementChange = new EventEmitter<any>();
  @Output() viewLess = new EventEmitter<any>();
  isInputCard1: boolean = true;
  isInputCard2: boolean = true;
  isInputCard3: boolean = true;
  isInputCard4: boolean = true;
  disbursementForm!: FormGroup;
  isLoading = false;
  hasError: boolean = false;
  private loader = inject(DisbursmentService);
  pdaEditData: any = null;
  pdaExpenses: any[] = [];
  @ViewChild('pdaExpensesDialog')
pdaExpensesDialog!: TemplateRef<any>;
  username!: any;
  expensesLabel: any;
  constructor(private fb: FormBuilder, private disbursementService: DisbursementService,
    private routes: Router, private snackBar: ToastrService, private dialog: MatDialog, private fileUploadService: FileUploadService,
    private datePipe: DatePipe, private pdaService: PdaService, private portAgentFormService: PortAgentFormService
  ) {

  }
  formatDate = formatDate;
  ngOnInit(): void {
    this.username = localStorage.getItem('username') ?? '';
    this.getDisbursmentDataDetailsFromDb(this.disbursement_obj);
  }

  isEditFun(id: number): void {
    switch (id) {
      case 1: this.isInputCard1 = !this.isInputCard1; break;
      case 2: this.isInputCard2 = !this.isInputCard2; break;
    }
  }


  ngOnChanges(changes: SimpleChanges): void {
    if (changes['disbursement_obj'] && this.disbursement_obj) {
      // this.buildForm();
      this.getDisbursmentDataDetailsFromDb(this.disbursement_obj);
    }
  }

statusOptions: string[] = ['Rejected', 'Cancelled'];

  // Automatically set FDA Status to 'Cancelled' whenever PDA Status is changed to 'Cancelled'
  onPdaStatusChange(event: Event): void {
    const selectedStatus = (event.target as HTMLSelectElement).value;
    if (selectedStatus === 'Cancelled') {
      this.disbursementForm.get('fda_status')?.setValue('Cancelled');
    }
  }
  buildForm(disbursementdetails: DisbursmentDetails) {
    this.disbursementForm = this.fb.group({
      disbursement_seq: [disbursementdetails?.disbursement_seq || null],
      disbursement_id: [disbursementdetails?.disbursement_id || null],
      client_name: [disbursementdetails?.client_name || null],
      port_agent_name: [disbursementdetails?.port_agent_name || null],
      port_agent_office_address: [disbursementdetails?.port_agent_office_address || null],
      pic: [disbursementdetails?.pic || null],
      ops_pic: [disbursementdetails?.ops_pic || null],
      agency_nomination_date: [disbursementdetails?.agency_nomination_date || null],
      invoice_number: [disbursementdetails?.invoice_number || null],
      pda_id: [disbursementdetails?.pda_id || null],
      pda_received_ops_agent: [disbursementdetails?.pda_received_ops_agent || null],
      pda_processing_date: [disbursementdetails?.pda_processing_date || null],
      pda_status: [disbursementdetails?.pda_status || null],
      portagent_pda_amount: [disbursementdetails?.portagent_pda_amount || null],
      actual_pda_amount: [disbursementdetails?.actual_pda_amount || null],
      pda_remittance: [disbursementdetails?.pda_remittance || null],
      pda_remark: [disbursementdetails?.pda_remark || null],
      fda_id: [disbursementdetails?.fda_id || null],
      fda_state: [disbursementdetails?.fda_state || null],
      fda_received_ops_agent: [disbursementdetails?.fda_received_ops_agent || null],
      fda_processing_date: [disbursementdetails?.fda_processing_date || null],
      portagent_fda_amount: [disbursementdetails?.portagent_fda_amount || null],
      actual_fda_amount: [disbursementdetails?.actual_fda_amount || null],
      fda_status: [disbursementdetails?.fda_status || null],
      fda_remark: [disbursementdetails?.fda_remark || null],
      days_outstanding: [disbursementdetails?.days_outstanding || null],
      vessel_name: [disbursementdetails?.vessel_name || null],
      voyage: [disbursementdetails?.voyage || null],
      vessel_imo: [disbursementdetails?.vessel_imo || null],
      port: [disbursementdetails?.port || null],
      country: [disbursementdetails?.country || null],
      purpose: [disbursementdetails?.purpose || null],
      cargo: [disbursementdetails?.cargo || null],
      eta: [disbursementdetails?.eta || null],
      etd: [disbursementdetails?.etd || null],
      sm_estimated_amount: [disbursementdetails?.sm_estimated_amount || 0],
      sm_detailed_entry: [disbursementdetails?.sm_detailed_entry || 'NA'],
      sm_ws_chart_ac: [disbursementdetails?.sm_ws_chart_ac || 'NA'],
      owners_item_rejected: [disbursementdetails?.owners_item_rejected || 'NA'],
      towage_agency_agrement: [disbursementdetails?.towage_agency_agrement || 'NA'],
      roe_agent: [disbursementdetails?.roe_agent || null],
      roe_actual_oanda: [disbursementdetails?.roe_actual_oanda || null],
      roe_loss: [disbursementdetails?.roe_loss || null],
      loss_prevention_pda: [disbursementdetails?.loss_prevention_pda || null],
      loss_prevention_fda: [disbursementdetails?.loss_prevention_fda || null],
      total_loss_prevented: [disbursementdetails?.total_loss_prevented || null],
      loss_prevented_reason: [disbursementdetails?.loss_prevented_reason || null],
      fda_receive_date: [disbursementdetails?.fda_receive_date || null],
      pda_receive_date: [disbursementdetails?.pda_receive_date || null],
      final_status: [disbursementdetails?.final_status || null],
      advance_percentage: [disbursementdetails?.advance_percentage || null],
      pda_ptm_curr_to: [disbursementdetails?.pda_ptm_curr_to || null],
      fda_ptm_curr_to: [disbursementdetails?.fda_ptm_curr_to || null],
      manual_pda_amount: [disbursementdetails?.manual_pda_amount || null],
      manual_fda_amount: [disbursementdetails?.manual_fda_amount || null],
      bank_details: [disbursementdetails?.bank_details || null],
      presigned_url: disbursementdetails?.presigned_url || null,
      pdf_name:disbursementdetails?.pdf_name || null,
    });
  }

  /** Fetches disbursement details data from the database. */
  getDisbursmentDataDetailsFromDb(disbursement_obj: Disbursment) {
    this.isLoading = true;
    this.disbursementService.getDisbursementDataDtls(disbursement_obj?.disbursement_seq).subscribe({
      next: (details) => {
        const disbursementDetails = new DisbursmentDetails(details);
        this.buildForm(disbursementDetails);
        if(disbursementDetails.fda_expenses?.length !== 0){
          this.expensesLabel = "FDA"
          this.pdaExpenses = disbursementDetails.fda_expenses || [];
        }else {
             this.pdaExpenses = disbursementDetails.pda_expenses || [];
             this.expensesLabel = "PDA"
        }
     
        this.isLoading = false;
      },
      error: (error) => {
        this.hasError = true;
        this.isLoading = false;
      }
    });
  }

  /** Handles retry logic for fetching disbursement details. */
  retryFetch() {
    this.hasError = false; // Reset error state
    this.getDisbursmentDataDetailsFromDb(this.disbursement_obj);
  }

  submitForm(id: number) {
    switch (id) {
      case 1: this.isInputCard1 = true; break;
      case 2: this.isInputCard2 = true; break;
    }
    if (this.disbursementForm.valid) {
      const formValue = { ...this.disbursementForm.value };

      // Convert dates to local ISO string
      if (formValue.pda_received_ops_agent) {
        formValue.pda_receive_date = formatToLocalISOString(formValue.pda_received_ops_agent);
      }
      if (formValue.fda_received_ops_agent) {
        formValue.fda_received_ops_agent = formatToLocalISOString(formValue.fda_received_ops_agent);
      }
      if (formValue.agency_nomination_date) {
        formValue.agency_nomination_date = formatToLocalISOString(formValue.agency_nomination_date);
      }
      if (formValue.fda_receive_date) {
        formValue.fda_receive_date = formatToLocalISOString(formValue.fda_receive_date);
      }

      formValue.pda_status = this.disbursementForm.get('pda_status')?.value;
      formValue.fda_status = this.disbursementForm.get('fda_status')?.value;
      this.disbursementChange.emit(formValue);
    }
  }

  // Function for Action Buttons 
  viewLessButton() {
    this.viewLess.emit();
    this.isInputCard1 = true;
  }

  viewPDA() {
    const disbursement_seq = this.disbursementForm.get('disbursement_seq')?.value;
    sessionStorage.setItem('disbursement_seq', disbursement_seq);
    // Navigate to the PDA component
    if (this.disbursementForm.get('pda_id')?.value != null) {
      this.routes.navigate(['dis-pda-edit']);
    } else {
      this.snackBar.warning("PDA not available for this disbursement");
    }
  }

  viewFDA() {
    const disbursement_seq = this.disbursementForm.get('disbursement_seq')?.value;
    sessionStorage.setItem('disbursement_seq', disbursement_seq);
    // Navigate to the FDA component
    if (this.disbursementForm.get('fda_id')?.value != null) {
      this.routes.navigate(['dis-fda-edit']);
    } else {
      this.snackBar.warning("FDA not available for this disbursement");
    }
  }
    viewTowage() {
    const disbursement_seq = this.disbursementForm.get('disbursement_seq')?.value;
    sessionStorage.setItem('disbursement_seq', disbursement_seq);
    // Navigate to the Towage component
    if (this.disbursementForm.get('fda_id')?.value != null || this.disbursementForm.get('pda_id')?.value != null) {
      this.routes.navigate(['dis-towage-edit']);
    } else {
      this.snackBar.warning("Towage not available for this disbursement");
    }
  }

  addFDA() {
    const disbursement_id = this.disbursementForm.get('disbursement_id')?.value;
    const pic = this.disbursementForm.get('pic')?.value;
    const idParam = `${disbursement_id} - ${pic}`;
    this.routes.navigate(['dis-fda'], {
    queryParams: {
      disbursement_id,
      pic
    }
  });
  }

  upload(): void {
    const isUpload = true;
    const disbursementId = this.disbursementForm.get('disbursement_id')?.value
    const disbursementSeq = this.disbursementForm.get('disbursement_seq')?.value;
    const data = {
      isUploadMode: isUpload,
      files: [],
      disbursementId,
      pdaId: this.disbursementForm.get('pda_id')?.value,
      fdaId: this.disbursementForm.get('fda_id')?.value,
      disbursement_seq: disbursementSeq,
      isDisbursment: true
    }
    const dialogConfig = new MatDialogConfig();
    dialogConfig.position = { right: '0' };
    dialogConfig.height = '100%';
    dialogConfig.width = '96vw';
    dialogConfig.maxWidth = '100vw';
    dialogConfig.panelClass = ['animate__animated', 'animate__slideInRight'];
    dialogConfig.data = data;
    const dialogRef = this.dialog.open(FileUploadDisComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((result) => {
      if (result === 'refresh') {
      }
    });
  }


  downloadReport(option: string) {

    if (option === "PDA" && this.disbursementForm.get('pda_id')?.value === null) {
      this.snackBar.warning("PDA not available for this disbursement");
    }
    else if (option === "FDA" && this.disbursementForm.get('fda_id')?.value === null) {
      this.snackBar.warning("FDA not available for this disbursement");
    }

    else {
      const data = {
        disbursement_seq: this.disbursementForm.get('disbursement_seq')?.value || null,
        report_type: option
      }
      this.loader.show();
      this.fileUploadService.downloadReport(data, this.disbursementForm.get('disbursement_id')?.value || null).subscribe({
        next: (res) => {
          this.loader.hide()

        }, error: (error) => {
          this.loader.hide()
          const errMsg = error.message || "Something went wrong please try again later.";
          this.snackBar.error(errMsg);
        }
      })
    }
  }
  resendPdaRequest() {
    this.loader.show();
    const data = { disbursement_seq: this.disbursementForm.get('disbursement_seq')?.value }
    this.pdaService.resendPdaLink(data).subscribe({
      next: (response) => {
        this.loader.hide();
        this.snackBar.success(response.message);
      },
      error: (error) => {
        this.loader.hide();
        const errMsg = error?.error?.error || "Something went wrong. Please try again later.";

        this.snackBar.error(errMsg);
      }
    })
  }


  calculateTotalLostPrevented() {
    const pdaValue = Number(this.disbursementForm.get('loss_prevention_pda')?.value) || 0;
    const fdaValue = Number(this.disbursementForm.get('loss_prevention_fda')?.value) || 0;
    const total = pdaValue + fdaValue;
    this.disbursementForm.get('total_loss_prevented')?.setValue(total);
  }

  calculateRoeLoss() {
    const actualRoe = Number(this.disbursementForm.get('roe_actual_oanda')?.value) || 0;
    const agentRoe = Number(this.disbursementForm.get('roe_agent')?.value) || 0;

    const roeLossRaw = actualRoe - agentRoe;
    const roeLoss = Number(roeLossRaw.toFixed(4));

    this.disbursementForm.get('roe_loss')?.setValue(roeLoss, { emitEvent: false });
  }

  private getFormValue(fieldName: string, defaultValue: string = ''): any {
    return this.disbursementForm?.get(fieldName)?.value || defaultValue;
  }

  openPaymentInstructionEmailDialog() {
    const pdaId = this.getFormValue('pda_id');
    const pdaStatus = this.getFormValue('pda_status');
    const fdaStatus = this.getFormValue('fda_status');
    const pdaAmount = Number(this.getFormValue('actual_pda_amount', '0'));
    const fdaAmount = Number(this.getFormValue('actual_fda_amount', '0'));
    

    const state = PaymentInstructionLogic.getPaymentInstructionState(
      pdaId,
      pdaStatus,
      fdaStatus,
      pdaAmount,
      fdaAmount
    );

    if (!state.isButtonVisible) {
      this.snackBar.warning('Payment Instruction is not available at this time');
      return;
    }

    const advancePay = Number(this.getFormValue('pda_remittance', '0'));
    const advancePercentage = this.disbursementForm.get('advance_percentage')?.value || 0;
    const dialogData = {
      to: [],
      cc: [],
      vesselName: this.getFormValue('vessel_name', 'VESSEL'),
      voyage: this.getFormValue('voyage', 'VOY'),
      port: this.getFormValue('port', 'PORT'),
      purpose: this.getFormValue('purpose', 'PURPOSE'),
      portAgent: this.getFormValue('port_agent_name', 'AGENCY'),
      port_agent_office_address: this.getFormValue('port_agent_office_address', ''),
      pdaAmount: state.amount.toString(),
      advancePay: advancePay.toString(),
      advancePercentage: advancePercentage,
      due: state.contentType === 'FDA' ? this.getFormValue('fda_processing_date') : this.getFormValue('pda_processing_date'),
      type: state.contentType,
      disbursement_id: this.getFormValue('disbursement_id'),
      pmt_curr_to: state.contentType === 'PDA' ? this.getFormValue('pda_ptm_curr_to', '') :
        this.getFormValue('fda_ptm_curr_to', ''),
      bankDetails: this.getFormValue('bank_details'),
      presignedUrl: this.getFormValue('presigned_url', ''),
      pdf_name: this.getFormValue('pdf_name', ''),
      disbursement_seq: this.getFormValue('disbursement_seq', ''),
      vessel_imo: this.getFormValue('vessel_imo', ''),

    };
    this.portAgentFormService.getMasterData({ fields: ['client'] }).subscribe({
      next: (response: any) => {
        const matchedClient = response.client?.find((c: any) => c.company_name === this.getFormValue('client_name'));
        this.loader.hide();

        dialogData.to = matchedClient?.email ? (Array.isArray(matchedClient.email) ? matchedClient.email : [matchedClient.email]) : [];
        dialogData.cc = dialogData.to;

        const dialogRef = this.dialog.open(PaymentInstructionDialogComponent, {
          disableClose: true,
          width: '900px',
          maxWidth: '90vw',
          maxHeight: '90vh',
          panelClass: ['rounded-dialog', 'theme-dark'],
          data: dialogData
        });
        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            this.loader.show();
            this.disbursementService.paymentInstructionEmail(result).subscribe({
              next: (res) => {
                this.loader.hide();
                this.dialog.open(EmailSentNotificationComponent, {
                  disableClose: true,
                  panelClass: 'email-dialog-style',
                  width: '400px',
                  height: '150px',
                });
              },
              error: (err) => {
                this.loader.hide();
                this.snackBar.error('Failed to send payment instruction email');
              }
            });
          }
        });
      },
      error: (err: any) => {
        this.loader.hide();
        this.snackBar.error('Failed to load client list');
      }
    });
  }

openPdaExpenses() {
  this.dialog.open(this.pdaExpensesDialog, {
    width: '850px',
    maxWidth: '90vw',
    maxHeight: '80vh',
    panelClass: 'theme-dark'
  });
}
}
